import { render, staticRenderFns } from "./TodoMain.vue?vue&type=template&id=72cd8166&scoped=true&"
import script from "./TodoMain.vue?vue&type=script&lang=js&"
export * from "./TodoMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cd8166",
  null
  
)

export default component.exports